import React from 'react';
import { bool, shape, object } from 'prop-types';

import { has } from 'lodash';

import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import HtmlTooltip from '../components/HtmlTooltip/HtmlTooltip';
import classes from './AgentStatus.module.css';

const CONNECTION_ICON_PROPS = {
    [false]: {
        alt: 'Disconnected',
        src: '/assets/images/removeIconRed.svg'
    },
    [null]: {
        alt: 'Not Available',
        src: '/assets/images/disconnectedIconGrey.svg'
    },
    [true]: {
        alt: 'Connected',
        src: '/assets/images/checkmarkIconGreen.svg'
    }
};

const ActiveActionStates = ['pending', 'inProgress'];

function getActiveActions(actions = {}) {
    const actionTypes = Object.keys(actions || {});
    const activeActions = actionTypes.filter(
        (actionType) => {
            if (actions[actionType]) {
                return ActiveActionStates.includes(actions[actionType].status);
            } else {
                return '';
            }
        }
    );
    return activeActions.map(action => {
        if (action === 'inventoryScan') {
            return 'Inventory Scanning';
        }
        if (action === 'factoryReset') {
            return 'Factory Resetting';
        }
        return `${action}ing`;
    });
}

function isErpAgent(agent) {
    return !has(agent, 'connected');
}

const AgentStatus = ({ agent, showLabel, showHtmlTooltip = false }) => {
    if (isErpAgent(agent)) {
        agent.connected = agent.connectionStatus ? true : false;
        if (agent.connectionStatus === null) {
            agent.connected = null;
        }
    }
    const activeActions = getActiveActions(agent.actions);
    const status = CONNECTION_ICON_PROPS[agent.connected];

    let label = status.alt;
    let icon = <img alt="" className={classes.icon} {...status} />;
    let tooltip = status.alt;

    if (agent.connected && activeActions.length) {
        icon = (
            <CircularProgress
                classes={{
                    root: classes.icon,
                    svg:  classes.svg
                }}
            />
        );
        label = activeActions[0];
        tooltip = activeActions.join(', ');
    }

    if (showHtmlTooltip) {
        return (
            <HtmlTooltip
                information={<React.Fragment><div>{tooltip}</div></React.Fragment>}
                placement="top"
                body={
                    <div className={classes.status}>
                        {icon}
                        {showLabel && label}
                    </div>
                }
            />
        );
    }
    else {
        return (
            <Tooltip
                classes={{tooltip: classes.tooltip}}
                placement="top"
                title={<span>{tooltip}</span>}
            >
                <div className={classes.status}>
                    {icon}
                    {showLabel && label}
                </div>
            </Tooltip>
        );
    }
};

AgentStatus.defaultProps = {
    showLabel: false
};

AgentStatus.propTypes = {
    agent: shape({
        actions:   object,
        connected: bool
    }).isRequired,
    showLabel: bool
};

export default AgentStatus;
